import React, { Component } from "react";
import "../../assets/css/App.css";
import './DashBoardStyles.css'
import KPI from "./KPI/KPI";
import MyTask from "./MyTask/MyTasks";
import auth from '../Auth'
import CandidateChartContainer from './Charts/CandidateCharts'
import DataChartContainer from "./Charts/RequistionCharts";
import { AppPermissions } from "../Shared/Constants/AppPermissions";
import { dateFormatter } from "../../HelperMethods";
import DashboardIcons from "./DashboardIcons";
export interface DashBoardComponentProps {
    match?: any;
    location?: any;
}
export interface DashBoardComponentState {
    key?: any;
}
class DashBoardComponent extends Component<DashBoardComponentProps, DashBoardComponentState> {

    constructor(props) {
        super(props)
        this.state = {
        }
    }
    componentDidMount(): void {
        document.body.classList.add("dashboard-page");
    }
    componentWillMount() {
        if (this.props.location.key) {
            this.setState({ key: this.props.location.key })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.location.key !== this.props.location.key) {
            this.setState({ key: nextProps.location.key })
        }
    }
    componentWillUnmount(): void {
        document.body.classList.remove("dashboard-page");
    }
    render() {
        const date = new Date();
        return (
            <div className='kpi__dashboard'>
                <div className="row title-kpi mt-2">
                    <div className="col-sm-4 col-12 pl-0">
                        <h1 className='heading1 text-white text-left mb-0'>
                            {/* Dashboard */}
                            <img width={180} alt="Ringo Vital Logo" src={DashboardIcons.ringoVitalLogo}/>
                        </h1>
                    </div>
                    <div className="col-md-8 col-sm-8 align-items-end d-flex justify-content-end">
                        <h2 className='heading2 text-white text-right mb-0'><span className="fw-semibold"> Today</span>, <span className="date-color">{dateFormatter(date)}</span></h2>
                    </div>
                </div>
                <div className="row">
                    <div className="card card-radius pl-4 pr-2 pb-4 kpi-left-panel mb-3">
                        <MyTask />
                    </div>
                    <div className="pr-md-0 kpi-right-panel-wrap">
                        <div className="kpi-right-panel">
                        <KPI />
                         {auth.hasPermissionV2(AppPermissions.REQ_WF_CHART_VIEW) && (
                            <DataChartContainer />
                        )} 
                        {auth.hasPermissionV2(AppPermissions.CAND_WF_CHART_VIEW) && (
                            <CandidateChartContainer />
                        )} 
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DashBoardComponent;
